var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Layout } from 'react-admin';
import AppBar from './AppBar';
import Menu from './Menu';
export default (function (props) { return (_jsx(Layout, __assign({}, props, { appBar: AppBar, menu: Menu }))); });
